import { ReadonlyURLSearchParams } from "next/navigation";
import { config } from "./config";

type GetSierraInstanceParams = {
  searchParams: ReadonlyURLSearchParams | null;
};

export const getSierraInstance = ({
  searchParams,
}: GetSierraInstanceParams): string => {
  const sierraInstance = config.SIERRA_KEY;

  const domain = searchParams?.has("sierra-staging")
    ? config.SIERRA_NON_PROD_DOMAIN
    : config.SIERRA_PROD_DOMAIN;

  return `${domain}/agent/${sierraInstance}/embed`;
};
